import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const DeliveryPartnersChart = ({ data }) => {
  const processedData = Array.isArray(data) ? data : [];

  const statusCount = processedData.reduce((acc, partner) => {
    acc[partner.status] = (acc[partner.status] || 0) + 1;
    return acc;
  }, {});

  const chartData = [
    { name: 'Available',   value: statusCount['Available']   || 0, color: '#10b981' },
    { name: 'Busy',        value: statusCount['Busy']        || 0, color: '#f59e0b' },
    { name: 'Unavailable', value: statusCount['Unavailable'] || 0, color: '#ef4444' },
  ].filter(item => item.value > 0);

  const total = processedData.length;

  if (total === 0) {
    return (
      <div className="chart-widget" style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#1a1a1a' }}>Delivery Partners Status</h3>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '120px', color: '#6b7280' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>🚚</div>
            <p style={{ fontSize: '12px', margin: 0 }}>No delivery partner data available</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="chart-widget" style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
      <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#1a1a1a' }}>Delivery Partners Status</h3>
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        {/* Fixed pixel dimensions — avoids ResponsiveContainer height:auto issue */}
        <div style={{ position: 'relative', width: '130px', height: '130px', flexShrink: 0 }}>
          <ResponsiveContainer width={130} height={130}>
            <PieChart>
              <Pie data={chartData} cx="50%" cy="50%" innerRadius={35} outerRadius={58} paddingAngle={2} dataKey="value">
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => [value, 'Partners']} contentStyle={{ backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '12px' }} />
            </PieChart>
          </ResponsiveContainer>
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center', pointerEvents: 'none' }}>
            <div style={{ fontSize: '20px', fontWeight: '700', color: '#1f2937', lineHeight: 1 }}>{total}</div>
            <div style={{ fontSize: '10px', color: '#6b7280' }}>Total</div>
          </div>
        </div>
        {/* Stats grid */}
        <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', minWidth: '120px' }}>
          {[
            { label: 'Available',   value: statusCount['Available']   || 0, bg: '#ecfdf5', color: '#10b981' },
            { label: 'Busy',        value: statusCount['Busy']        || 0, bg: '#fef3c7', color: '#f59e0b' },
            { label: 'Unavailable', value: statusCount['Unavailable'] || 0, bg: '#fee2e2', color: '#ef4444' },
          ].map((item, i) => (
            <div key={i} style={{ padding: '10px', background: item.bg, borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: '700', color: item.color }}>{item.value}</div>
              <div style={{ fontSize: '10px', color: item.color, fontWeight: '500' }}>{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeliveryPartnersChart;
